import { render, staticRenderFns } from "./TenantDeleteConfirmationModal.vue?vue&type=template&id=a1082cb2&"
import script from "./TenantDeleteConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./TenantDeleteConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports